import { render, staticRenderFns } from "./TaskHeat.vue?vue&type=template&id=4f42e8a2&scoped=true"
import script from "./TaskHeat.vue?vue&type=script&lang=js"
export * from "./TaskHeat.vue?vue&type=script&lang=js"
import style0 from "./TaskHeat.vue?vue&type=style&index=0&id=4f42e8a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f42e8a2",
  null
  
)

export default component.exports